<template>
  <div class="wrapper">
    <pulldown-page
      class="page"
      :background="background"
      color="#333333"
      :refresh="pulldown"
      :style="{ 'padding-top': (fullProcess ? 0 : statusBarHeight || 0) + 'px' }"
    >
      <!-- 引导api导流列表 -->
      <template v-if="!fullProcess">
        <template v-if="isFanzhou">
          <fanzhou-page v-on:handleDownload="download"/>
        </template>
        <template v-else>
          <div class="interest-free">
            <img
              src="./images/icon_intrest_redpacket_banner.png"
              alt="banner"
              class="banner"
            >
            <img
              :src="gmImg?require('./images/img_0@2x.png'):require('./images/icon_intrest_redpacket_bg.png')"
              alt="redpacket"
              class="redpacket"
            >
            <section>
              <nd-button
                :class="gmImg?'button animation':'button'"
                @click="download"
              >下载{{ isIos === 'IOS' ? packageKey : '天美贷' }}立即{{gmImg?"提现":"领取"}}
                <img
                  class="hand"
                  src="./images/img_shou.png"
                  srcset=" ./images/img_shou@2x.png 2x,  ./images/img_shou@3x.png 3x  "
                  v-if="!gmImg"
                />
              </nd-button>
              <div class="list-item">
                <div class="item">
                  <img
                    src="./images/icon_01.png"
                    srcset=" ./images/icon_01@2x.png 2x, ./images/icon_01@3x.png 3x  "
                  />
                  <div class="text-1">快速审批</div>
                  <div class="text-2">最快5分钟放款</div>
                </div>
                <div class="item">
                  <img
                    src="./images/icon_02.png"
                    srcset="  ./images/icon_02@2x.png 2x,  ./images/icon_02@3x.png 3x "
                  />
                  <div class="text-1">分期偿还</div>
                  <div class="text-2">可分12期偿还</div>
                </div>
                <div class="item">
                  <img
                    src="./images/icon_03.png"
                    srcset="./images/icon_03@2x.png 2x, ./images/icon_03@3x.png 3x "
                  />
                  <div class="text-1">放心使用</div>
                  <div class="text-2">正规持牌机构</div>
                </div>
              </div>
            </section>
            <footer>
              <!-- ©️ 2017-2020 天美贷版权所有 -->
            </footer>

          </div>
          <section class="compliance">
            <p>贷款额度，放款时间，还款方式，还款期限等以实际审批结果为准(综合年化利率区间15.4%-36%%，单利计算)</p>
            <p>贷款有风险，请根据个人能力合理贷款，理性消费，避免逾期</p>
          </section>
        </template>
      </template>
      <template
        v-else
      >
        <navigation
          arr-theme="black"
          :sticky="false"
          :theme="{background: 'transparent',color: '#fff'}"
          customClickEvent
          @click="navigateToHome"
        ></navigation>
        <template v-if="
          [
            'CREDIT_ERROR',
            'CREDIT_EXPIRE',
            'CREDIT_REFUSED',
            'PRE_REFUSED'
        ].includes(creditStatus) && userInfo.hasDiversion"
        >
          <!-- 根据/result/v1/page接口数据决定展示哪个banner -->
          <template v-if="bannerStyle === 'UNUSED_PRIVILEGE'">
            <unused-privilege
              flow="credit"
              :retryCouponSerialId="pageInfo.retryCouponSerialId"
            ></unused-privilege>
          </template>
          <template v-else-if="bannerStyle === 'REFUSED_AUTH'">
            <refused-auth
              :deadTime="reapplyTime"
            ></refused-auth>
          </template>
          <template v-else-if="bannerStyle === 'CREDIT_RESULT'">
            <refused-box
              show-place="CREDIT_RESULT"
              :step="privilegeStep"
              :source='source'
              :refusedAd="refusedAd"
              :isVipValidate="refusedBoxStatus"
            ></refused-box>
          </template>
        </template>
        <div
          class="refused"
          v-else-if="creditStatus === 'CREDIT_REVIEW'"
        >
          <div v-if="isKingWait" class="king-wait">
            <div class="badge">
              插队申请中
            </div>
          </div>
          <div v-else class="animation-wapper">
            <lottie
              ref="animataion"
              :options="showGif[0]"
              v-on:animCreated="handleAnimation"
            />
          </div>
          <h1>授信审核中</h1>
          <p v-if="isKingWait">尊敬的会员，已为您启用<span>VIP专属</span>审核通道</p>
          <p v-else>我们正在加急为您审核，请您耐心等待</p>
          <button @click="navigateToHome">返回首页</button>
        </div>
        <div  class="pass" v-else-if="creditStatus === 'CREDIT_SUCCESS'"  >
          <div class="card">
            <img
              src="./images/img_tongguo.png"
              srcset="./images/img_tongguo@2x.png 2x, ./images/img_tongguo@3x.png 3x "
            />
            <h1 class="underline">恭喜您，</h1>
            <h1>
              获得额度<span class="bold">{{
                creditLimit | currency
              }}</span>
            </h1>
            <p>放款快，利率低，立即发起提现吧</p>
            <nd-button
              class="solid-button"
              @click="navigateToWithdraw"
            >立即提现</nd-button>
            <button
              class="text-button"
              @click="navigateToHome"
            >
              返回首页
            </button>
          </div>
        </div>
        <div
          v-if="showPrivilegeBanner"
          class="privilege-box"
          :class="{'pt400': false}"
        >
          <div
            class="privilege-content"
            :class="{ani: (showPrivilegeBanner && showReviewButton)}"
            data-sensors-click
            data-sensors-exposure-event-name="Element_Exposure"
            data-sensors-exposure-property-caseId="SKC_M"
          >
            <img
              class="box-icon"
              src="./images/icon_tanhao.png"
            >
            您的申请暂未通过
            <!-- 至尊王卡资格（未购买/已失效）用户，展示‘特权重审’按钮 -->
            <template v-if="showReviewButton">
              ，<span
                class="box-strong"
                v-stat="{id: 20299}"
                data-sensors-click
                @click="jumpToKingCardPage"
              >立即重审，通过率翻倍 >></span>
            </template>
          </div>
        </div>
        <template v-if="!isQlc">
          <footer
            v-if="creditStatus"
            class="mt40"
          >
            <div :class="['CREDIT_REFUSED', 'PRE_REFUSED'].includes(creditStatus)&&'borrow-list'">
              <borrow-list
                status="credit"
                :step="privilegeStep"
                show-place="CREDIT_RESULT"
                type="river_diversion"
                v-show="['CREDIT_REFUSED', 'PRE_REFUSED'].includes(creditStatus)"
                :source='source'
                show-sub
                show-tips
                show-swipe
                title="借款推荐"
              />
            </div>
          </footer>
        </template>
        <!-- 引导用户参加活动 -->
        <div
          class="activity-container"
          v-if="showActivity&&hasJsBridge"
          :class="!(creditStatus&&channel==='official')&&'mt137'"
        >
          <img
            class="logo"
            src="./images/icon_hongbao@2x.png"
          />
          <div class="text">
            <h1>活动资格达标！</h1>
            <p>「拒就赔」怎么任性怎么玩！</p>
          </div>
          <nd-button
            class="button"
            @click="goActivity"
          >领取红包</nd-button>
        </div>
      </template>
      <!-- 广告位 -->
      <div class="ad-container"
           data-sensors-exposure-event-name="Element_Exposure"
           v-if="['CREDIT_REFUSED'].includes(creditStatus) && userInfo.hasDiversion && ['UN_BUY', 'EXPIRED'].includes(privilegeUsed) && banner.jumpUrl"
      >
        <a :href="banner.jumpUrl" data-sensors-click class="ad"> <img  :src="banner.image" /> </a>
      </div>
      <download-guide ref="downloadGuide"></download-guide>
      <nd-dialog
        v-model="dialog4"
        closeBtn
        :footer="false"
      >
        <div class="service-dialog3">
          <div class="description">您当前如需使用权益功能，请更新至最新版本。 您可前往「天美贷-我的」点击「版本更新」进行升级。</div>
          <div class="flex">
            <nd-button
              class="btn small"
              @click="jumpHome"
            >立即升级</nd-button>
          </div>
        </div>
      </nd-dialog>
      <refused-privilege-dialog
        v-model="buyGuideVisible"
        status="credit"
        :amount="privilegeAmount"
        :price="price"
        :expirePrice="expirePrice"
        :expireDate="expireDate"
        :supplier="supplier"
        :couponInfo="couponInfo"
        @on-success="hanldeBuySuccess"
      ></refused-privilege-dialog>
      <ios-download v-model="downloadVisible"></ios-download>
      <ios-wxmp-dialog v-model="iosWxmpQRCodeDialogVisible"></ios-wxmp-dialog>
      <ios-wxmp-link-dialog v-model="iosWxmpLinkDialogVisible"></ios-wxmp-link-dialog>
      <web-clip-pop v-model="webclipPopVisible" @onClose="webclipPopVisible=false"/>
      <web-clip-copy-pop v-model="copyPopVisible" @onClose="copyPopVisible=false"/>
      <buy-dialog-jw
        v-model="buyVisible"
        :copyUrl="payUrl"
        @on-complete="queryPrivilegeDetail"
      ></buy-dialog-jw>
    </pulldown-page>
    <api-sheet
      ref="apiSheet"
      v-if="shoulShowApiSheet"
      :show="needApiGuideBottomSheet"
      :pageType="pageType"
      @needsShowListPop="needsShowApiListPopUp"
      @on-apiSheetClose="apiPageClose"
    />
    <nd-dialog
      class="api-list-popup"
      v-model="apiListPopVisible"
      :closeBtn="true"
      :footer="false"
    >
      <api-list-pop :items="apiListPopItems" @confirmApply="apiListPopUpApply"/>
    </nd-dialog>
  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import axios from '@/assets/axios'
import {
  getKey,
  setKey,
  judgeClientSystem,
  copyToClipbord,
  isEmptyObject
} from '@/assets/utils'
import { jsBridge, hasNativeMethod } from '@/assets/jsBridge'
import DownloadGuide from './components/download-guide'
import Lottie from 'vue-lottie'
import { fail, wait } from '@/assets/json/index'
import BorrowList from '@/components/borrow-list'
import RefusedBox from '@/components/refused-box'
import RefusedAuth from './components/refused-auth'
import UnusedPrivilege from '@/components/unused-privilege'
import RefusedPrivilegeDialog from '@/components/refused-privilege-dialog'
import IosDownload from '@/components/ios-download'
import IosWxmpDialog from '@/components/ios-wxmp-qrcode-dialog'
import IosWxmpLinkDialog from '@/components/ios-wxmp-link-dialog'
import WebClipPop from '@/view/landing/components/web-clip-pop.vue'
import WebClipCopyPop from '@/view/landing/components/web-clip-copy-pop.vue'
import BuyDialogJw from '@/components/buy-dialog-jw'
import apiPage from './api-auth/api-page'
import fanzhouPage from './components/fanzhou-page'
import apiSheet from './api-guide-sheet.vue'
import apiListPop from './components/api-list-pop.vue'
import isIntercept from '@/assets/intercept-mixin'

const PAGE_TYPE = 'CREDIT_REFUSAL_API_GUIDE'

const privilegeSteps = {
  'UN_BUY': 'credit',
  'EXPIRED': 'credit',
  'UN_USE': 'credit2',
  'USED': 'credit3'
}
const privilegeUsedStatus = {
  'SUC_USE': 'USED',
  'OVERDUE': 'EXPIRED',
  'USE_OVER': 'EXPIRED',
  'DEFAULT': 'UN_USE'
}


export default {
  components: {
    DownloadGuide,
    Lottie,
    BorrowList,
    RefusedBox,
    RefusedAuth,
    UnusedPrivilege,
    RefusedPrivilegeDialog,
    IosDownload,
    BuyDialogJw,
    apiPage,
    fanzhouPage,
    apiSheet,
    apiListPop,
    WebClipPop,
    WebClipCopyPop,
    IosWxmpDialog,
    IosWxmpLinkDialog
  },
  name: 'authentication-result',
  customReadyNotify: true,
  data () {
    return {
      banner: {},
      couponInfo: {},
      buyVisible: false,
      payUrl: '', // 及未支付链接，传给弹窗组件
      downloadVisible: false,
      iosWxmpQRCodeDialogVisible: false,
      iosWxmpLinkDialogVisible: false,
      webclipPopVisible: false,
      copyPopVisible: false,
      landing: this.$route.query.landing, // 是否落地页，值为T，需要和渠道h5-fz一起判断
      home: this.$route.query.home, // 是否直接跳转首页，值为T
      auto: this.$route.query.auto, // 是否自动下载，值为T
      speedMemberStatus: null,
      price: 29.9,
      privilegeAmount: 29.9,
      expirePrice: 0,
      expireDate: 0,
      supplier: '',
      privilegeUsed: 'UN_BUY',
      refusedAd: {},
      showGif: [{ animationData: wait }, { animationData: fail, loop: false }],
      applyNo: this.$route.query.applyNo,
      creditStatus: null,
      reapplyTime: null,
      creditLimit: 0,
      channel: this.$route.query.channel || getKey('channel') || 'official',
      fullProcess: true,
      isIos: judgeClientSystem(),
      couponStatus: null,
      day: 0,
      currentNode: null,
      dialog4: false, // 为了解决安卓页面兼容的问题，用户于老版本券包页面跳转及授信/提现结果页跳转进权益卡
      source: window.location.href,
      queryExamine: null,
      needApiGuideBottomSheet: false, // 引导API列表弹窗
      buyGuideVisible: false, // 引导购买弹窗
      needsShowBuyGuide: false, // 是否需要显示引导购买弹窗,临时存放
      apiListPopItems: [],
      apiListPopVisible: false,
      pageType: PAGE_TYPE,
      pageInfo: null,
      goodsCd: '' // 会员对应编码，埋点使用
    }
  },
  watch: {
    creditStatus (value, preValue) {
      if (!['CREDIT_REVIEW'].includes(value)) {
        if (this.queryExamine) {
          clearInterval(this.queryExamine)
          this.creditStatus = preValue
          window.location.reload()
        }
      }
    }
  },
  beforeRouteLeave (to, form, next) {
    clearInterval(this.queryExamine)
    next((vm) => {})
  },
  async created () {
    // 导流注册渠道注册拦截
    await isIntercept(this.$route.query.channel)
    // 进行是否需要补充资料的检查
    await this.fillProcess()
    const shouldContinue = await this.getApplyListAndShowType()
    if (!shouldContinue) {
      return
    }
    await this.initialize()
    this.getBanner()
    this.$bus.$emit('ready')
  },
  computed: {
    ...mapState({
      hasJsBridge: (state) => state.hasJsBridge,
      statusBarHeight: (state) => state.statusBarHeight
    }),
    ...mapState('user', {
      userInfo: (state) => state.userInfo
    }),
    ...mapState('activities', {
      qualificationCoupon: (state) =>
        state.qualificationCoupon ? state.qualificationCoupon[0] || {} : {}
    }),
    isFanzhou () {
      // 泛舟渠道
      return this.channel.toLowerCase() === 'h5-fz'
    },
    gmImg () {
      // 什么国美渠道
      return this.channel.toLowerCase() === 'h5-gmql'
    },
    background () {
      return this.fullProcess ? '#fff' : '#f97378'
    },

    showActivity () {
      return this.qualificationCoupon.qualification &&
        this.qualificationCoupon.couponStatus !== 'USED' &&
        ['CREDIT_REFUSED'].includes(this.creditStatus)
    },
    privilegeStep () {
      return privilegeSteps[this.privilegeUsed]
    },
    // 是否展示重审横幅
    showPrivilegeBanner () {
      /*
      拒绝情况下
      已购买小美VIP/小美SVIP/小美会员 且在有效期内的用户且广告位存在有效导流产品
      或
      至尊王卡资格（未购买/已失效）用户 且（运营系统未屏蔽对应权益或存在有效导流产品）时
      展示横幅
      */
      return this.creditStatus === 'CREDIT_REFUSED' &&
        (
        (this.isVipValidate && !isEmptyObject(this.refusedAd)) ||
        (this.hasKingCardQualifications &&
        (this.pageInfo.showKingMember === 'Y' || !isEmptyObject(this.refusedAd))
        )
        )
    },
    showReviewButton () {
      // 有购买资格且运营系统未屏蔽对应权益
      return this.hasKingCardQualifications && this.pageInfo.showKingMember === 'Y'
    },
    bannerStyle () {
      if (!this.pageInfo) { return '' }
      const {
        haveRacmMember,
        showRacmMember,
        haveKingMember,
        showKingMember,
        retryCouponUsed
      } = this.pageInfo
      // 授信重审卡有效期内
      const haveRacm = haveRacmMember === 'Y'
      // 是否展示授信重审卡权益
      const showRacm = showRacmMember === 'Y'
      // 至尊卡有效期内
      const haveKing = haveKingMember === 'Y'
      // 是否展示至尊卡权益
      const showKing = showKingMember === 'Y'
      // 是否已使用重审
      const couponUsed = retryCouponUsed === 'Y'
      // 有权益且运营系统未屏蔽对应权益
      const haveAndShouldShowPrivilege = (haveRacm && showRacm) || (haveKing && showKing)
      if (couponUsed) {
        return 'REFUSED_AUTH'
      } else {
        return haveAndShouldShowPrivilege ? 'UNUSED_PRIVILEGE' : 'CREDIT_RESULT'
      }
    },
    showPrivilege () {
      if (!this.pageInfo) { return false }
      return this.pageInfo.showRacmMember === 'Y' || this.pageInfo.showKingMember === 'Y'
    },
    // 是否有其他会员（vip/svip/小美会员）
    isVipValidate () {
      if (!this.pageInfo) { return false }
      return this.pageInfo.haveOtherMember === 'Y'
    },
    // 是否有至尊卡购买资格
    hasKingCardQualifications () {
      if (!this.pageInfo) { return false }
      return this.pageInfo.kingBuyQualification === 'Y'
    },
    refusedBoxStatus () {
      if (!this.pageInfo) { return false }
      const {
        haveRacmMember,
        showRacmMember,
        haveKingMember,
        showKingMember
      } = this.pageInfo
      // 授信重审卡有效期内
      const haveRacm = haveRacmMember === 'Y'
      // 是否展示授信重审卡权益
      const showRacm = showRacmMember === 'Y'
      // 至尊卡有效期内
      const haveKing = haveKingMember === 'Y'
      // 是否展示至尊卡权益
      const showKing = showKingMember === 'Y'

      if (!showRacm && !showKing) { return true }
      if (this.hasKingCardQualifications) { return !showKing }
      if (this.isVipValidate) { return true }
      if ((!haveRacm || !showRacm) && (!haveKing || !showKing)) { return true }
      // if (((haveRacm && !showRacm) || (haveKing && !showKing)) && retryCouponUsed === 'N') {
      //   return true
      // }
      return false
    },
    isKingWait () {
      if (!this.pageInfo) { return false }
      return this.pageInfo?.haveKingMember === 'Y'
    },
    shoulShowApiSheet () {
      return (this.$route.query?.channel && this.$route.query.channel.toLowerCase() !== 'h5-fz') || !this.$route.query.channel
    }
  },
  methods: {
    ...mapActions('user', ['getUserInfoX', 'getBorrowList', 'showStatusX', 'apiApplyListX', 'adBanner']),
    ...mapActions('authentication', ['getCreditResultX', 'getApiListPageShowType', 'fillProcessX', 'getResultPageInfo']),
    ...mapActions('activities', [
      'couponListX',
      'couponDetailX'
    ]),
    ...mapActions('vip', [
      'queryDetailX',
      'getBuyQualification'
    ]),
    async initialize () {
      const channelFlag = await this.checkChannel()
      if (channelFlag) {
        return
      }
      const userHasDiversionOrInCreditQueue = await this.checkIfUserHasDiversionOrInCreditQueue()
      if (!userHasDiversionOrInCreditQueue) {
        return
      }
      // 获取是否是全流程
      await this.getProcessType()
      // 获取导流产品
      await this.queryDiversionProduct()
      // 获取页面所需展示条件
      await this.getResultPageInfoX()
      // 是否需要特权弹窗
      await this.checkIfNeedsShowPrivilegePop()
    },
    // initialize方法拆分
    // 检查渠道
    async checkChannel () {
      const flag = ['h5-fz', 'h5-gmql'].includes(this.channel.toLowerCase()) && this.landing === 'T'
    
      if (flag) {
        this.fullProcess = false
        await this.getAppInfo()
        if (this.auto === 'T') {
          await this.download()
        }
      }
      return flag
    },
    // 检查用户是否是导流用户或在授信流程中
    async checkIfUserHasDiversionOrInCreditQueue () {
      const userInfo = await this.getUserInfoX({ forceUpdate: true })
      const hasDiversionOrInCreditQueue = userInfo.hasDiversion || userInfo.creditQueue
      if (!hasDiversionOrInCreditQueue) {
        this.$router.replace(
          `/authentication/result2?applyNo=${this.applyNo}`
        )
      }
      if (userInfo.privilegeCardDetail && userInfo.privilegeCardDetail.raCard) {
        const { raCard } = userInfo.privilegeCardDetail
        this.privilegeUsed = privilegeUsedStatus[raCard.status] || privilegeUsedStatus['DEFAULT']
      }
      return hasDiversionOrInCreditQueue
    },
    // 获取是否是全流程
    async getProcessType () {
      const res = await axios.post('/order/v1/biz-route', {
        channelNo: this.channel
      })
      if (res.data.success) {
        this.fullProcess = !res.data.data.half
        this.currentNode = res.data.data.currentNode

        if (this.fullProcess || this.currentNode === 'CREDIT_RESULT') {
          await this.getCreditResult()
          if (this.creditStatus === 'CREDIT_REVIEW' && !this.queryExamine) {
            this.queryExamine = setInterval(async () => {
              await this.getCreditResult()
            }, 10000)
          }
        }
      }
    },
    // 获取导流产品信息
    async queryDiversionProduct () {
      const { success, data } = await this.getBorrowList({
        showPlace: 'CREDIT_RESULT',
        queryBanner: true,
        version: 'V2'
      })
      if (success) {
        if (data.showPlaceSwitch !== 'Y') {
          // 如果该页面被禁用，则跳转清洁版
          return this.$router.replace(
            `/authentication/result2?applyNo=${this.applyNo}`
          )
        }
        const { bannerConfigsV2 } = data
        this.refusedAd =
          bannerConfigsV2 && bannerConfigsV2.length && bannerConfigsV2[0]
            ? bannerConfigsV2[0].config
            : {}
        if (this.refusedAd && this.refusedAd.configId) {
          this.$report({
            id: 10002,
            args: { position: 'banner', target: this.refusedAd.configId, screen: 'credit' }
          })
        }
      }
    },
    // 获取页面所需的判断条件
    async getResultPageInfoX () {
      const { success, data } = await this.getResultPageInfo({
        page: 'CREDIT'
      })
      if (success) {
        this.pageInfo = data || {}
        return
      }
      this.pageInfo = {}
    },
    // 是否需要特权弹窗
    async checkIfNeedsShowPrivilegePop () {
      if (this.showPrivilege) {
        if (
          ['CREDIT_REFUSED', 'PRE_REFUSED'].includes(this.creditStatus) &&
          this.userInfo.hasDiversion &&
          ['UN_BUY', 'EXPIRED'].includes(this.privilegeUsed) &&
          this.$route.query.noDialog !== 'T'
        ) {
          await this.queryPrivilegeDetail()
          // 不在小美会员 小美vip svip 特权卡有效期内 且没有小美会员购买资格
          this.$report({
            id: 20999,
            args: {
              position: 'credit_review_buy',
              type: this.supplier
            }
          })
          // 1天只弹出一次
          if (this.isIntervalDay('buyGuideVisible', 1)) {
            this.$nextTick(() => {
              this.needsShowBuyGuide = this.hasKingCardQualifications && this.pageInfo.showKingMember === 'Y'
              // needApiGuideBottomSheet must be have value
              if (!this.needApiGuideBottomSheet && !this.buyGuideVisible) {
                this.setBuyGuideVisible()
              }
              this.$sensors.track('PopupDisplay', { msg_name: this.goodsCd })
            })
          }
        }
      }
    },
    // 校验用户是否是需要去补充资料银行卡的人群
    async fillProcess () {
      return new Promise(async (resolve) => {
        const { success, data } = await this.fillProcessX()
        if (success) {
          if (data.process === 'NON') {
            resolve()
          } else {
            this.$router.replace(`/authentication/pre-base`)
          }
        }
      })
    },
    async getBanner () {
      const { success, data } = await this.adBanner({
        riskBannerType: 'CREDIT_REJECTION'
      })
      if (success) {
        this.banner = data
      }
    },
    // 获取至尊卡详情
    async queryPrivilegeDetail () {
      const { success, data } = await this.queryDetailX({
        goodsCd: 'SKC_M'
      })
      if (success) {
        this.privilegeAmount = data.discountPrice
        this.expirePrice = data.expirePrice
        this.expireDate = data.expireDate
        this.supplier = data.goodsSupplier
        this.speedMemberStatus = data.memberStatus
        this.price = data.price
        this.goodsCd = data.goodsCd
        this.couponInfo = data.couponInfo
      }
    },
    // 跳转首页
    jumpHome () {
      this.dialog4 = false
      if (hasNativeMethod('navigateTo')) {
        jsBridge('navigateTo', { path: 'login', exitCurrent: true })
      }
    },
    handleAnimation (anim) {
      this.anim = anim
    },
    // 下拉刷新
    async pulldown () {
      window.location.reload()
    },
    navigateTo (path, replace) {
      if (replace) {
        this.$router.replace(path)
      } else {
        this.$router.push(path)
      }
    },
    navigateToHome () {
      if (hasNativeMethod('exit') && judgeClientSystem() !== 'IOS') {
        jsBridge('exit')
      } else {
        this.navigateTo('/')
      }
    },
    navigateToWithdraw () {
      this.$report({
        id: 10085
      })
      if (hasNativeMethod('navigateTo') && (judgeClientSystem() !== 'IOS' || (judgeClientSystem() === 'IOS' && getKey('appChannel') === 'official-iOS'))) {
        jsBridge('navigateTo', { path: 'withdraw', exitCurrent: true })
      } else {
        this.$router.push('/withdraw/index')
      }
    },
    async getCreditResult () {
      if (
        !this.applyNo ||
        this.applyNo === 'null' ||
        ['h5-gmql'].includes(this.channel.toLowerCase())
      ) {
        this.fullProcess = false
        return
      }
      this.fullProcess = true
      const res = await this.getCreditResultX({
        loanPlatform: 'TMD',
        applyNo: this.applyNo
      })
      if (res.success) {
        this.creditStatus = res.data.creditStatus
        this.$sensors.track('Results_Page_View', { page_status: res.data.creditStatus, additinal_status: this.privilegeStep })
        const { meetSVIP, creditLimit, increaseLockAmount, creditQueue, showPassCardBuy } =
          res.data || {}

        if (showPassCardBuy === 'Y') {
          this.$router.replace(`/authentication/result-pass`)
          return
        }

        if (creditQueue) {
          return this.$router.replace({
            path: '/authentication/wait',
            query: { applyNo: this.applyNo }
          })
        }
        if (meetSVIP) {
          this.$router.replace({
            path: '/ssvip/result',
            query: { creditLimit, increaseLockAmount }
          })
          return
        }
        if (this.creditStatus === 'UNCREDIT') {
          this.$router.push('/')
        }
        if (['CREDIT_REFUSED'].includes(this.creditStatus)) {
          this.$report({
            id: 10084,
            args: {
              status: 3,
              message: res.msg
            }
          })
          this.reapplyTime = res.data.reapplyTime
        }
        if (this.creditStatus === 'CREDIT_SUCCESS') {
          this.creditLimit = res.data.creditLimit
          this.$report({
            id: 10084,
            args: {
              status: 1
            }
          })
        }
        if (this.creditStatus === 'CREDIT_REVIEW') {
          this.$report({
            id: 10084,
            args: {
              status: 2
            }
          })
        }
      }
    },
    async download () {
      await this.downloadApp()
    },
    // 去参加活动
    goActivity () {
      this.$report({
        id: 10129,
        args: {
          status: this.qualificationCoupon.couponDetailType
        }
      })
      this.$router.push({
        path: '/activities/compensation',
        query: {
          activeType: 'PAY_IF_REFUSE_NEW',
          loanPlatform: 'TMD',
          couponId: this.qualificationCoupon.couponRecordId
        }
      })
    },
    
    clickCloseHandler () {
      this.$report({ id: 50024 })
    },
    // 下单成功
    hanldeBuySuccess (payUrl) {
      this.payUrl = payUrl
      copyToClipbord(this.payUrl)
      this.buyVisible = true
      this.handleBuyPolling()
    },
    // 购买弹窗后轮询(轮询10次或状态已购买则不再轮询)
    handleBuyPolling () {
      let times = 1
      const timer = setInterval(() => {
        if (times > 10 || this.speedMemberStatus === 'NORMAL') {
          clearInterval(timer)
        } else {
          times += 1
          this.queryPrivilegeDetail()
        }
      }, 30 * 1000)
    },
    needsShowApiListPopUp (items) {
      this.apiListPopVisible = true
      this.apiListPopItems = items
    },
    apiListPopUpApply () {
      this.apiListPopVisible = false
      this.$refs.apiSheet.confirmApply(this.apiListPopItems)
    },
    async getApplyListAndShowType () {
      /**
     * 判断是否有一键申请的数据
     * 有跳转到一键申请页面 return
     * 没有就在结果页走老流程
     */
      const { success, data } = await this.apiApplyListX({
        pageType: this.pageType
      })
      if (success && data && data.configs && data.configs.length) {
        const { success, data } = await this.getApiListPageShowType()
        if (success) {
          this.needApiGuideBottomSheet = data.status
          if (!data.status) {
            this.setBuyGuideVisible()
          }
          return true
        } else {
          this.$router.replace(`/authentication/api-page?pageType=${this.pageType}`)
          return false
        }
      }
      return true
    },
    apiPageClose () {
      this.needApiGuideBottomSheet = false
      if (!this.pageInfo) {
        return
      }
      setTimeout(() => {
        this.setBuyGuideVisible()
      }, 500)
    },
    setBuyGuideVisible () {
      this.buyGuideVisible = this.needsShowBuyGuide
      setKey('buyGuideVisible', Date.now())
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.wrapper {
  height: 100%
}
.ad-container {
  padding: 20px;

  img {
    width: 100%;
  }
}
.pt400 {
  padding-top: 400px !important;
}
.download-container {
  display: flex;
  align-items: center;
  width: 672px;
  height: 140px;
  padding-left: 30px;
  padding-right: 30px;
  margin: 298px auto 83px;
  border-radius: 20px;
  background: linear-gradient(
    90deg,
    rgba(255, 179, 92, 0.1) 0%,
    rgba(253, 122, 22, 0.1) 100%
  );
  &.showactivity {
    margin-top: 20px;
  }
  .logo {
    width: 80px;
    height: 80px;
    margin-right: 20px;
  }
  .text {
    flex: 1;
    > h1 {
      font-size: 30px;
      color: rgba(51, 51, 51, 1);
      line-height: 42px;
    }
    > p {
      font-size: 24px;
      color: rgba(102, 102, 102, 1);
      line-height: 33px;
    }
  }
  .button {
    width: 160px;
    height: 60px;
    line-height: 60px;
    background: linear-gradient(
      90deg,
      rgba(255, 179, 92, 1) 0%,
      rgba(253, 122, 22, 1) 100%
    );
    font-size: 28px;
    border-radius: 10px;
  }
}
.mt137 {
  margin-top: 137px;
}
.activity-container {
  display: flex;
  align-items: center;
  width: 672px;
  height: 140px;
  padding-left: 30px;
  padding-right: 30px;
  margin: 20px auto 0;
  border-radius: 20px;
  background: linear-gradient(
    90deg,
    rgba(255, 179, 92, 1) 0%,
    rgba(253, 122, 22, 1) 100%
  );
  .logo {
    width: 80px;
    height: 80px;
    margin-right: 20px;
  }
  .text {
    flex: 1;
    > h1 {
      font-size: 30px;
      color: #ffffff;
      line-height: 42px;
    }
    > p {
      font-size: 24px;
      color: #ffffff;
      line-height: 33px;
    }
  }
  .button {
    width: 160px;
    height: 60px;
    line-height: 60px;
    background: transparent;
    font-size: 28px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 1);
  }
}
.page {
  font-size: 28px;
  height: unset;
  overflow: scroll;
  padding-bottom: 20px !important;
  .highlight {
    color: #ff4633 !important;
  }
  .bold {
    font-size: 72px;
    font-weight: 500;
    font-family: DIN-Medium, DIN; //需要引入字体文件
  }
  .refused {
    overflow: hidden;
    padding-top: 283px;
    > img {
      display: block;
      width: 190px;
      height: 190px;
      margin: 0 auto 50px;
    }
    .king-wait {
      width: 162px;
      height: 174px;
      margin: 0 auto;
      background: url(./images/img_wait_clean_king.png) no-repeat;
      background-size: 100%;
      margin-bottom: 20px;
      .badge {
        width: 150px;
        height: 46px;
        background: #FFE2BD;
        border-radius: 100px 100px 100px 0px;
        font-size: 24px;
        font-weight: 400;
        color: #763E12;
        line-height: 46px;
        text-align: center;
        position: absolute;
        top: 379px;
        left: 434px;
      }
    }
    .animation-wapper {
      height: 210px;
      width: 210px;
      margin: 0 auto;
    }
    > h1 {
      font-size: 42px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      text-align: center;
    }
    > p {
      margin-top: 15px;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      text-align: center;
      > span {
        color: #FF4633
      }
    }
    > button {
      display: block;
      width: 320px;
      height: 80px;
      margin: 66px auto 0;
      border-radius: 40px;
      border: 2px solid rgba(255, 70, 51, 1);
      background-color: #fff;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 70, 51, 1);
    }
  }
  .pass {
    // height: 100vh;
    padding: 188px 45px;

    .card {
      overflow: hidden;
      position: relative;
      height: 100%;
      padding: 243px 73px 0;
      background: linear-gradient(
        180deg,
        rgba(255, 247, 237, 1) 0%,
        rgba(254, 254, 254, 1) 100%
      );
      border-radius: 30px;
      > img {
        position: absolute;
        top: -90px;
        right: -94px;
        width: 367px;
        height: 367px;
      }
      > h1 {
        font-size: 42px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 59px;
        margin-top: 30px;
        &.underline {
          position: relative;
          &::after {
            position: absolute;
            left: 0;
            bottom: -10px;
            content: "";
            width: 130px;
            height: 10px;
            background: linear-gradient(
              90deg,
              rgba(255, 179, 92, 1) 0%,
              rgba(253, 122, 22, 1) 100%
            );
          }
        }
      }
      > p {
        margin-top: 48px;
        font-size: 30px;
        color: rgba(102, 102, 102, 1);
      }
      .solid-button {
        display: block;
        width: 320px;
        height: 80px;
        line-height: 80px;
        border-radius: 40px;
        font-size: 32px;
        margin: 74px auto 40px;
      }
      .text-button {
        display: block;
        width: 320px;
        font-size: 32px;
        color: rgba(255, 70, 51, 1);
        text-align: center;
        margin: auto;
        border: none;
        background: transparent;
      }
    }
  }
  .half-process {
    .header {
      width: 750px;
      height: 450px;
      margin: 0 auto;
      background-image: url(./images/half_result_header.png);
      background-size: 100%;
    }

    .half-content {
      background-color: #fafafa;
      padding: 50px;

      .credit-limit {
        text-align: center;
        padding-top: 50px;

        .text {
          font-size: 34px;
          font-weight: 400;
          color: #333333;
          line-height: 48px;
        }

        .limit {
          font-size: 112px;
          font-weight: 500;
          color: #333333;
          line-height: 136px;
          margin-top: -20px;
        }
      }

      .download {
        text-align: center;

        .text-button {
          height: 40px;
          font-size: 28px;
          font-weight: 400;
          color: #f5a166;
          line-height: 40px;
          margin-top: 50px;
        }

        .normal-button {
          width: 650px;
          height: 94px;
          background: linear-gradient(90deg, #ff3333, #ff5f34);
          border-radius: 47px;
          margin-top: 44px;

          .icon-arrow {
            font-size: 32px;
          }
        }
      }

      .product-feature {
        width: 650px;
        height: 210px;
        background: #ffffff;
        border-radius: 20px;
        box-shadow: 4px 6px 8px 8px rgba(243, 243, 243, 0.5);
        padding: 35px 45px;
        margin-top: 94px;

        .feature-item {
          font-size: 26px;
          font-weight: 400;
          text-align: left;
          color: #666666;
          line-height: 37px;
          position: relative;
          padding-left: 30px;

          & + .feature-item {
            margin-top: 18px;
          }

          &::before {
            content: "";
            width: 14px;
            height: 14px;
            background-color: #f5a166;
            position: absolute;
            left: 0;
            border-radius: 7px;
            top: 10px;
          }
        }
      }

      .copyright {
        text-align: center;
        height: 28px;
        font-size: 20px;
        font-weight: 400;
        color: #999999;
        line-height: 28px;
        margin-top: 110px;

        span {
          margin-left: 20px;
        }
      }
    }
  }
  .privilege-box {
    .privilege-content {
      width: 670px;
      height: 70px;
      background: #FF4633;
      border-radius: 16px;
      display: flex;
      align-items: center;
      padding: 0 10px;
      margin: 18px auto 20px;
      font-size: 28px;
      color: #fff;
      &.ani {
        animation: btnScale 1s linear infinite;
      }
      .box-icon {
        width: 40px;
        height: 40px;
        margin-right: 15px;
      }
      .box-strong {
        color: #FFF56A;
      }
    }
  }
  .mt40 {
    margin-top: 40px;
  }
  footer {
    // position: absolute;
    // bottom:90px;
    // left:40px;
    margin: auto;
    // padding-bottom:20px;
    .mt180 {
      margin-top: 300px;
    }
    .borrow-list {
      min-height: 200px;
    }
    .footer-img {
      display: block;
      margin: 20px auto 0;
      width: 670px;
      height: 170px;
    }
  }
}
.xiaohua {
  header {
    height: 490px;
    background: url(./images/bg_01@2x.png);
    background-size: 100% 100%;
    overflow: hidden;
    .slogan {
      display: flex;
      align-items: center;
      font-size: 28px;
      color: #ffffff;
      margin-top: 38px;
      padding: 0 38px;
      .logo {
        width: 48px;
        height: 48px;
        margin-right: 12px;
      }
    }
    .credit-limit {
      margin-top: 90px;
      text-align: center;
      color: #ffffff;
      &__text {
        font-size: 42px;
        line-height: 60px;
      }
      &__amount {
        font-size: 130px;
        font-family: DIN, DIN-Medium;
        font-weight: 500;
        line-height: 1;
        margin-top: -10px;
        .symbol {
          font-size: 68px;
        }
      }
      &__tip {
        width: 330px;
        height: 48px;
        line-height: 48px;
        background: rgba(255, 212, 212, 0.25);
        border-radius: 5px;
        font-size: 22px;
        margin: 15px auto 0;
      }
    }
  }
  section {
    @keyframes hand {
      0% {
        transform: translateY(-15px);
      }
      50% {
        transform: translateY(15px);
      }
      100% {
        transform: translateY(-15px);
      }
    }
    .jujiupei {
      width: 540px;
      height: 187px;
      background: url(./images/jujiupei@2x.png) center center no-repeat;
      background-size: 100% 100%;
      overflow: hidden;
      margin: 97px auto 0;
      &__slogan {
        margin-top: 60px;
        padding-left: 163px;
        font-size: 36px;
        font-weight: 600;
        color: #333333;
        line-height: 50px;
      }
      &__tip {
        padding-left: 163px;
        font-size: 27px;
        color: #ff4633;
        line-height: 40px;
      }
    }
    .button {
      position: relative;
      width: 600px;
      height: 94px;
      line-height: 94px;
      margin: 60px auto 0;
      font-size: 36px;
      font-weight: 500;
      .hand {
        position: absolute;
        right: 13px;
        top: 50px;
        width: 100px;
        height: 110px;
        animation: hand 1s ease infinite;
      }
    }
    .list-item {
      display: flex;
      justify-content: space-between;
      padding: 0 60px;
      margin-top: 134px;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        > img {
          width: 90px;
          height: 90px;
        }
        .text-1 {
          margin-top: 18px;
          font-size: 28px;
          text-align: center;
          color: #333333;
          line-height: 40px;
        }
        .text-2 {
          font-size: 24px;
          text-align: center;
          color: #999999;
          line-height: 40px;
        }
      }
    }
  }
  footer {
    margin-top: 130px;
    margin-bottom: 35px;
    font-size: 20px;
    text-align: center;
    color: #999999;
    line-height: 28px;
  }
}
.interest-free {
  // padding-bottom: 120px;
  .banner {
    width: 750px;
    height: 520px;
  }
  .redpacket {
    width: 750px;
    height: 420px;
    margin-top: -120px;
  }
  .button {
    position: relative;
    width: 600px;
    height: 94px;
    line-height: 94px;
    margin: 60px auto 0;
    font-size: 36px;
    font-weight: 500;
    .hand {
      position: absolute;
      right: 13px;
      top: 50px;
      width: 100px;
      height: 110px;
      animation: hand 1s ease infinite;
    }
  }
  .animation {
    animation: button 1.5s linear infinite;
  }
  @keyframes button {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(0.85);
    }
    100% {
      transform: scale(1);
    }
  }
  .list-item {
    display: flex;
    justify-content: space-between;
    padding: 0 60px;
    margin-top: 134px;
    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      > img {
        width: 90px;
        height: 90px;
      }
      .text-1 {
        margin-top: 18px;
        font-size: 28px;
        text-align: center;
        color: #333333;
        line-height: 40px;
      }
      .text-2 {
        font-size: 24px;
        text-align: center;
        color: #999999;
        line-height: 40px;
      }
    }
  }
  footer {
    // left: 50%;
    // transform: translateX(-50%);
    // position: fixed;
    // bottom: 36px;
    margin-bottom: 36px;
    font-size: 20px;
    text-align: center;
    color: #999999;
    margin-top: 79px;
    line-height: 28px;
  }
}
.compliance {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 160px;
  background: #fffaf5;
  line-height: 160px;
  color: #d0bfb0;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  overflow: hidden;
  box-sizing: border-box;
  padding: 28px 30px;
  p {
    line-height: 1.6em;
  }
}
.service-dialog3 {
  text-align: left;
  padding: 0 48px 38px;
  .description {
    margin-top: 31px;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  .thick {
    font-weight: 700 !important;
  }
  .btn {
    width: 300px;
    height: 80px;
    line-height: 80px;
    margin: 40px auto 0;
  }
  .grey {
    background: white;
    color: #333;
    border: 1px solid #333;
    margin: 20px auto 0 !important;
  }
}
/deep/.api-list-popup {
  .nd-dialog{
    z-index: 9999 !important;
  }
  .nd-mask {
    z-index: 4000 !important;
  }
}
</style>
